module.exports = __webpack_public_path__ + "img/cover.99bf253a.png";